import { useCurrentEntity } from '@identity/hooks';
import { organizationTodayIso } from '@load-balancing/services';

export function useOrganizationTodayIso(): string {
  const { defaultTimeZone } = useCurrentEntity();

  return organizationTodayIso(defaultTimeZone);
}
